import {
  CompletePartnerConfig,
  PartialPartnerConfig,
  PartnerFeatures,
} from 'V2/Types/PartnerConfig';

const QUOTE_MAGIC_PARTNER_FEATURES: Partial<PartnerFeatures> = {
  showMiddleName: false,
  showSuffix: false,
  useYesNoAddVehicle: true,
  useYesNoDriverMilitaryService: true,
  allowUserInputAddressLookup: true,
  showInvalidAddressModal: false,
  showBundleQuoteRequested: true,
  useVehicleYearMakeModelSplit: true,
  showContactPhone: true,
};

const QUOTE_MAGIC_PARTNER_CONFIG = {
  labels: { nextStep: 'Continue', edit: 'Save' },
  features: QUOTE_MAGIC_PARTNER_FEATURES,
} satisfies PartialPartnerConfig;

const DEFAULT_PARTNER_FEATURES: PartnerFeatures = {
  showMiddleName: true,
  showSuffix: true,
  useYesNoAddVehicle: false,
  useYesNoDriverMilitaryService: false,
  allowUserInputAddressLookup: false,
  showInvalidAddressModal: true,
  showBundleQuoteRequested: false,
  useVehicleYearMakeModelSplit: false,
  showContactPhone: false,
};

const DEFAULT_PARTNER_CONFIG = {
  labels: { nextStep: 'Next', edit: 'Save' },
  features: DEFAULT_PARTNER_FEATURES,
} satisfies CompletePartnerConfig;

export const PARTNER_CONFIGS = {
  QUOTE_MAGIC: QUOTE_MAGIC_PARTNER_CONFIG,
  DEFAULT: DEFAULT_PARTNER_CONFIG,
} satisfies {
  DEFAULT: CompletePartnerConfig;
  QUOTE_MAGIC: PartialPartnerConfig;
};
